module.exports = __webpack_public_path__ + "01_mole.5e1bf36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/01_mole.png
// module id = vRjS
// module chunks = 0